import { forwardRef } from 'react';
import vizzleImageData from '../../vizzle-logo-data-image';
import { filterUndefined } from '../../../utils/FilterUndefinedObject';
import './StudentUsernamesPrint.scss';

const defaultProps = {
  currentUser: {},
  students: [],
};

const StudentUsernamesPrint = forwardRef((props, ref) => {
  const { currentUser, students } = { ...defaultProps, ...filterUndefined(props) };
  return (
    <div className='student-usernames-print' ref={ref}>
      <div className='vizzle-logo'>
        <img src={vizzleImageData} alt='Vizzle Logo' />
      </div>
      <div className='header'>
        List of Student Usernames for
        <br />
        <div className='username' data-dd-privacy='mask'>{currentUser?.userName}</div>
      </div>
      <div className='student-list'>
        {students.map((student) => (
          <div className='student' key={`print-student-${student.id}`}>
            <div className='username' data-dd-privacy='mask'>
              {student.userName}
            </div>
            <div className='name' data-dd-privacy='mask'>
              {student.firstName} {student.lastName}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
});

export default StudentUsernamesPrint;
